module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAsCAYAAABPEGliAAAAF0lEQVQoU2PkmfrhPwMDAwPjKGOgAwEA+Ptw7fZS8lYAAAAASUVORK5CYII="